import { connect } from "react-redux";
import BenchmarkBarChart from "./BenchmarkBarChart";


const mapStateToProps = (state) => ({

    fetchTotalFeedbackProvidersStrengthAndDevApi: state.BenchmarkFilteringReducer.fetchTotalFeedbackProvidersStrengthAndDevApi

});

const mapDispatchToProps = (dispatch) => ({




});

export default connect(mapStateToProps, mapDispatchToProps)(BenchmarkBarChart);
